module.exports = __webpack_public_path__ + "img/private-napolimania-salad-1.9068cdd7.jpg";